module.exports = __webpack_public_path__ + "static/media/mnożenie_i_dzielenie_w_zakresie_30.c86c6b24.pdf";